import React from 'react';

const SortAlphaAscIcon = ({ style, onClick }) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        style={{ width: '16px', height: '16px', cursor: 'pointer', ...style }}
        onClick={onClick}
    >
        <path d="M3 4h4" />
        <path d="M5 4v7" />
        <path d="M3 15h4" />
        <path d="M5 15v-3.5" />
        <path d="M14 8h7" />
        <path d="M14 12h5" />
        <path d="M14 16h3" />
        <path d="m18 4-3 3 3 3" />
    </svg>
);

export default SortAlphaAscIcon;
